import "./User.css";

import { Breadcrumb, message, Table, type TableColumnsType, Tag } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { SectionHeader, TableMenuDropdown } from "../../_lib/_components";
import {
  deleteUser,
  getUsers,
  useAppSelector,
  type UserType,
} from "../../_lib/_store";

export const UserPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, users } = useAppSelector((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getUsers(messageApi);
  };

  const columns: TableColumnsType<UserType> = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Is Registration Complete",
      dataIndex: "isRegistrationComplete",
      key: "isRegistrationComplete",
      render: (v) => <Tag>{v ? "Yes" : "No"}</Tag>,
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (v) => <Tag color="gray">{v}</Tag>,
    },
    {
      title: "Email Verified",
      dataIndex: "emailVerified",
      key: "emailVerified",
      render: (v) => <Tag>{v ? "Yes" : "No"}</Tag>,
    },
    {
      title: "Purchase Flag",
      dataIndex: "purchaseFlag",
      key: "purchaseFlag",
      render: (v) => <Tag>{v ? "Yes" : "No"}</Tag>,
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const handleMenuClick = (key: string, obj: UserType) => {
    switch (key) {
      case "show":
        navigate(`/user/show`, { state: { user: obj } });
        break;
      case "edit":
        navigate(`/user/edit`, { state: { user: obj } });
        break;
      case "delete":
        deleteUser(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="user">
        <div className="header">
          <Breadcrumb
            items={[
              {
                title: <Link to="/dashboard">Dashboard</Link>,
              },
              {
                title: "User",
              },
            ]}
          />
        </div>
        <SectionHeader dataLength={users?.length} createRoute="user" />
        <Table
          sticky
          dataSource={users}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1000 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
